import script from "./ResponseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponseModal.vue?vue&type=script&setup=true&lang=js"

import "./ResponseModal.vue?vue&type=style&index=0&id=79b4f618&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b4f618"]])

export default __exports__